import { BaseEndpoint } from "../base.endpoint"
import { Params, Headers } from "../../types/request"
import { VatMemberAttributes } from "../../types/attributes"

export class Vat extends BaseEndpoint {
  public async isVatMember(
    params?: Params,
    headers?: Headers
  ): Promise<VatMemberAttributes> {
    const { data } = await this.http.get(this.routes.isVatMember(), {
      params,
      headers,
    })
    return data
  }
}
